import styled from 'styled-components';

export const HeaderWrapper = styled.div`

    background: white;
    border-bottom: 1px solid #cdcdcd;

    header {
        display: flex;
        flex-basis: 90px;
        align-items: flex-start;
        gap: 10px;
        box-sizing: border-box;
    }

    header .logo {
        flex: 1;
        display: flex;
        gap: 5px;
        padding: 7px 8px 0px 8px;
    }
    .h-btn {
    margin: 2px;
    --
    }
    // .h-btn:hover {
    //     background: var(--avaya_grey_dark);
    //     color: var(--avaya_grey)
    //     transition:.2s ease all;
    // }

    .btn-close {
        transition:.2s ease all;
        background: var(--avaya_red);
        color: var(--avaya_grey_light)
    }
    .btn-close:hover {
        background: var(--avaya_grey);
        color: var(--avaya_red)
    }

    .btn-close:disabled {
         opacity:.5;
    }
`;
